import Icon from '../components/Icon.vue'

Icon.register({"flag":{"width":512,"height":512,"paths":[{"d":"M349.6 98.8C296 98.8 251.7 64 184.3 64 159.4 64 137 68.4 116.3 76A55.9-55.9 0 0 1 119.9 52.5C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56 8 75 17.5 91.8 32 101.9V488C32 501.3 42.7 512 56 512H72C85.3 512 96 501.3 96 488V393.6C124.3 381.5 159.6 371.5 210.4 371.5 264 371.5 308.3 406.3 375.7 406.3 423.8 406.3 462.3 390 498.2 365.4 506.8 359.5 512 349.6 512 339V95.9C512 72.6 487.7 57.1 466.5 66.9 432.2 82.9 390.1 98.8 349.6 98.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/flag.js
// module id = null
// module chunks = 